

































































































































































































import DateMixin from "@/mixins/DateMixin";
import AccountIdValdationMixin from "@/mixins/AccountIdValdationMixin";
import { DalModule } from "@/store/dal.module";
import { Component, Mixins } from "vue-property-decorator";
import DatePicker from "@/components/ui/DatePicker.vue";
import FormValidator from "@/mixins/FormValidator";
import { LocaleService } from "@/services/locale.service";
import { ReportsModule } from "@/store/reports.module";
import moment from "moment";
import GlobalMixin from "@/mixins/GlobalMixin";

@Component({
  components: { DatePicker },
})
export default class CalculateView extends Mixins(
  DateMixin,
  AccountIdValdationMixin,
  FormValidator,
  GlobalMixin,
) {
  formRef = "calculateForm";
  countsStart: number = null as any;
  countsEnd: number = null as any;
  countsStartNT: number = null as any;
  countsEndNT: number = null as any;
  period = {
    from: "",
    to: "",
    min: "",
    max: "",
  };

  get counter() {
    return DalModule.counter.length > 0 ? DalModule.counter[0] : (null as any);
  }

  checkMoreWhen() {
    return (
      !this.countsEnd ||
      !this.countsStart ||
      Number.parseFloat(this.countsEnd.toString()) >=
        Number.parseFloat(this.countsStart.toString()) ||
      this.$t("form-validator.checkMoreWhen")
    );
  }

  checkMoreWhenNT() {
    return (
      !this.countsEndNT ||
      !this.countsStartNT ||
      Number.parseFloat(this.countsEndNT.toString()) >=
        Number.parseFloat(this.countsStartNT.toString()) ||
      this.$t("form-validator.checkMoreWhen")
    );
  }

  checkDates() {
    return (
      !this.period.to ||
      !this.period.from ||
      moment(this.period.to) > moment(this.period.from) ||
      this.$t("form-validator.checkDates")
    );
  }

  async clickCalc() {
    if (!this.validateForm()) return;
    const locale = LocaleService.getLocale();
    await ReportsModule.generateReport({
      action: "open",
      path: `calc-result-${locale}.prpt`,
      type: "pdf",
      filename: "filename",
      query: {
        account_id: DalModule.AccountId,
        prev_check_date: moment(this.period.from).format("YYYYMMDD"),
        last_check_date: moment(this.period.to).format("YYYYMMDD"),
        is_night_time_exist: this.is_night_time_exist,
        prev_check_count: this.countsStart,
        last_check_count: this.countsEnd,
        prev_check_count_night_time: this.is_night_time_exist
          ? this.countsStartNT
          : 0,
        last_check_count_night_time: this.is_night_time_exist
          ? this.countsEndNT
          : 0,
      },
    });
  }

  get is_night_time_exist() {
    return DalModule.counter && DalModule.counter.length > 1;
  }

  async mounted() {
    await this.validateAccountId();
    if (!this.$route.params.id) {
      this.$router.push({ name: "account-info" });
      return;
    }
    const acc = Number.parseInt(this.$route.params.id);
    if (acc) {
      DalModule.setAccountId(acc);
    }
    await DalModule.getCntCheckInfo(DalModule.AccountId);
  }
}
